// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2Ohq4","footer":"ModalError_footer__1CNvi"};